<template>
  <div style="margin-top: 30px">
    <b-overlay :show="showLoading" no-wrap />

    <b-popover container="lg-popover" target="my_popover" placement="buttom" triggers="hover">
      <template #title>
        Vente à distance - Obligations relatives au démarchage téléphonique en
        assurances
      </template>
      <p>
        Dans le cadre de votre mission, vous vous engagez &agrave; respecter
        l&rsquo;ensemble des r&egrave;gles relatives au d&eacute;marchage
        t&eacute;l&eacute;phonique, y compris la loi n&deg;2021-402 du 8 avril
        2021, le d&eacute;cret n&deg;2022-34 du 17 janvier 2022 et le
        d&eacute;cret n&deg;2022-1313 du 13 octobre 2022.
      </p>
      <p><u>Vos obligations </u>:</p>
      <ul>
        <li>
          Mettre en place une vente en deux temps lorsque vous d&eacute;marchez
          par t&eacute;l&eacute;phone un prospect qui n&rsquo;est pas client ou
          qui n&rsquo;a pas sollicit&eacute; votre appel de mani&egrave;re
          active.
        </li>
        <li>
          Informer le prospect d&egrave;s le d&eacute;but de l&rsquo;appel que
          celui-ci est enregistr&eacute; et qu&rsquo;il peut obtenir une copie
          de cet enregistrement s&rsquo;il en fait la demande.
        </li>
        <li>
          Mettre fin &agrave; l&rsquo;appel si le prospect refuse
          l&rsquo;enregistrement.
        </li>
        <li>
          Vous vous engagez &agrave; enregistrer l&rsquo;ensemble des
          conversations t&eacute;l&eacute;phoniques qui auront amen&eacute;
          &agrave; la conclusion du contrat d&rsquo;assurance et &agrave; les
          conserver.&nbsp;
        </li>
        <li>
          La signature &eacute;lectronique ne pourra intervenir lors du
          deuxi&egrave;me appel et vous ne pourrez pas l&rsquo;accompagner
          durant ce processus de signature.
        </li>
        <li>
          S&rsquo;assurer de permettre la tra&ccedil;abilit&eacute; et
          l&rsquo;int&eacute;grit&eacute; de l&rsquo;ensemble des appels
          t&eacute;l&eacute;phoniques.
        </li>
        <li>
          Respecter strictement le d&eacute;cret du 13 octobre 2022 encadrant
          les jours, horaires et fr&eacute;quence d&rsquo;appels quand celui-ci
          s&rsquo;applique. Les appels dans ce cas devront &ecirc;tre
          pass&eacute;s entre 10h et 13h et entre 14h &agrave; 20h du lundi au
          vendredi. Ils sont en revanche interdits les samedis, dimanches et
          jours f&eacute;ri&eacute;s. Cet encadrement s&#39;applique aussi bien
          aux personnes non inscrites sur la liste Bloctel qu&#39;&agrave;
          celles inscrites mais sollicit&eacute;es dans le cadre d&#39;un
          contrat en cours.
        </li>
        <li>
          Limitation stricte de l&#39;acc&egrave;s aux enregistrements aux seuls
          agents de l&#39;Autorit&eacute; de contr&ocirc;le prudentiel et de
          r&eacute;solution et aux agents mentionn&eacute;s aux articles L.
          511-3 et L. 511-21 du code de la consommation.
        </li>
      </ul>
      <p><u>Destruction des enregistrements</u> :</p>
      <ul>
        <li>
          Sans d&eacute;lai, lorsque le souscripteur ou l&#39;adh&eacute;rent
          &eacute;ventuel s&#39;est explicitement oppos&eacute; &agrave; la
          poursuite de la communication t&eacute;l&eacute;phonique ou &agrave;
          la proposition commerciale
        </li>
        <li>
          En l&#39;absence de r&eacute;ponse favorable &agrave; une proposition
          commerciale, dans un d&eacute;lai d&#39;un mois &agrave; compter de la
          date de cette proposition (le souscripteur ou l&#39;adh&eacute;rent
          &eacute;ventuel manifestant ainsi une absence
          d&#39;int&eacute;r&ecirc;t ou son souhait de ne pas donner suite
          &agrave; cette proposition)
        </li>
      </ul>
    </b-popover>
    <validation-observer ref="AssureRules">
      <b-form>
        <!--Assuré principal-->
        <b-row>
          <b-col md="12">
            <b-form-group id="lg-popover">
              <label class="font-weight-normal" style="font-size: 1rem">Cette souscription s'effectue-t-elle dans le
                cadre d'une vente
                à distance ?
                <span class="d-inline-block" variant="outline-primary" id="my_popover"><feather-icon icon="InfoIcon"
                    class="cursor-pointer" size="21" /></span></label>
              <b-form-radio-group v-model="devis.is_a_distance" :options="optionsVenteDistance"
                name="radio-vente-a-distance" />
            </b-form-group>

            <b-form-group label="De quel type de vente s'agit-il ?" v-if="devis.is_a_distance">
              <validation-provider #default="{ errors }" name="type de vente" rules="required">
                <b-form-radio-group v-model="devis.type_vente" name="radio-type-de-vente"
                  :state="errors.length > 0 ? false : null">
                  <b-form-radio :value="option.value" v-for="option in optionsTypeVente" :key="option.value">
                    {{ option.text }}
                    <span v-b-popover.hover.top="option.infoBool" v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                      :title="option.text" class="ml-1 cursor-pointer" variant="outline-primary">
                      <feather-icon icon="InfoIcon" size="20" />
                    </span>
                  </b-form-radio>
                </b-form-radio-group>
                <b-form-invalid-feedback :state="errors.length > 0 ? false : null">{{ errors[0] }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!-- Date d'effet -->
          <b-col md="3">
            <span v-b-popover.hover.top.html="infoDateEffet" v-ripple.400="'rgba(113, 102, 240, 0.15)'" title="Informations"  class="" variant="outline-primary">
              <b-form-group label="Date d'effet *" label-for="date-effet">
                <validation-provider #default="{ errors }" name="date d'effet" rules="required">
                  <flat-pickr id="date-effet" v-model="objetIJH.date_effet"
                    :class="errors.length > 0 ? 'is-invalid' : ''" :config="configdateEffet" class="form-control"
                    placeholder="Date d'effet" rules="required" autocomplete="off" />
                  <b-form-invalid-feedback :state="errors.length > 0 ? false : null">
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </validation-provider>
              </b-form-group>
            </span>
          </b-col>
          <b-col md="12">
            <h4 class="title-custom-wizard">
              <u>Assuré principal (signataire)</u>
            </h4>
          </b-col>
          <b-col md="12">
            <b-row>
              <!-- Civilité -->
              <b-col md="3">
                <b-form-group label="Civilité *" label-for="assure_civilite">
                  <validation-provider #default="{ errors }" name="civilité" rules="required">
                    <b-form-select v-model="prospect.civilite" :options="civilite" id="assure_civilite"
                      :state="errors.length > 0 ? false : null" />
                    <b-form-invalid-feedback :state="errors.length > 0 ? false : null">{{ errors[0] }}
                    </b-form-invalid-feedback>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <!-- Nom -->
              <b-col md="3">
                <b-form-group label="Nom *" label-for="assure_nom">
                  <div class="form-control" readonly disabled v-if=" prospect.statut_gda == 'ORANGE' || prospect.statut_gda == 'ROUGE' || prospect.statut_gda == 'VERT' ">
                    {{ prospect.nom }}
                  </div>
                  <validation-provider v-else #default="{ errors }" name="nom" rules="required">
                    <!-- <b-form-input v-if="prospect.statut_gda==='VERT'" v-model="prospect.nom" disabled :state="errors.length > 0 ? false : null" id="assure_nom" class="text-capitalize" placeholder="Nom" type="text" /> -->

                    <b-form-input v-model="prospect.nom" :state="errors.length > 0 ? false : null" id="assure_nom"
                      class="text-capitalize" placeholder="Nom" type="text" />

                    <b-form-invalid-feedback :state="errors.length > 0 ? false : null">{{ errors[0] }}
                    </b-form-invalid-feedback>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <!-- Prénom -->
              <b-col md="3">
                <b-form-group label="Prénom *" label-for="assure_prenom">
                  <div class="form-control" readonly disabled v-if="
                      prospect.statut_gda == 'ORANGE' ||
                      prospect.statut_gda == 'ROUGE' ||
                      prospect.statut_gda == 'VERT'
                    ">
                    {{ prospect.prenom }}
                  </div>
                  <validation-provider v-else #default="{ errors }" name="prénom" rules="required">
                    <!-- <b-form-input v-if="prospect.statut_gda==='VERT'" v-model="prospect.prenom" :state="errors.length > 0 ? false : null" id="assure_prenom" disabled class="text-capitalize" placeholder="Prénom" type="text" /> -->

                    <b-form-input v-model="prospect.prenom" :state="errors.length > 0 ? false : null" id="assure_prenom"
                      class="text-capitalize" placeholder="Prénom" type="text" />
                    <b-form-invalid-feedback :state="errors.length > 0 ? false : null">{{ errors[0] }}
                    </b-form-invalid-feedback>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <!-- Date de naissance -->
              <b-col md="3">
                <b-form-group label="Date de naissance *" label-for="date-naissance">
                  <div class="form-control" readonly disabled v-if="  prospect.statut_gda == 'ORANGE' ||  prospect.statut_gda == 'ROUGE' ||  prospect.statut_gda == 'VERT'">
                    {{ prospect.date_naissance }}
                  </div>

                  <validation-provider v-else #default="{ errors }" name="date de naissance" rules="required">
                    <!-- <flat-pickr v-if="prospect.statut_gda==='VERT'" id="date-naissance" disabled v-model="prospect.date_naissance" :class="errors.length > 0 ? 'is-invalid' : ''" :config="configDateNaissance" class="form-control" placeholder="Date de naissance" autocomplete="off" /> -->

                    <flat-pickr id="date-naissance" v-model="prospect.date_naissance"
                      :class="errors.length > 0 ? 'is-invalid' : ''" :config="configDateNaissance" class="form-control"
                      placeholder="Date de naissance" autocomplete="off" />
                    <b-form-invalid-feedback :state="errors.length > 0 ? false : null">
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                    <b-form-invalid-feedback :state="errorDateNaissanceProspect ? false : null">
                      {{ errorDateNaissanceProspect }}
                    </b-form-invalid-feedback>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <!-- Situation familiale -->
              <b-col md="3">
                <b-form-group label="Situation familiale*" label-for="situation_familiale">
                  <validation-provider #default="{ errors }" name="Situation familiale" rules="required">
                    <b-form-select v-model="prospect.situation_familiale" id="situation_familiale">
                      <b-form-select-option :value="null" disabled>Choisissez</b-form-select-option>
                      <b-form-select-option v-for="(val, value) in situationFamiliale" :key="value" :value="val.value" :state="errors.length > 0 ? false : null">{{val.name}}</b-form-select-option>
                    </b-form-select>
                    <b-form-invalid-feedback :state="errors.length > 0 ? false : null"> {{ errors[0] }} </b-form-invalid-feedback>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <!-- Code postal -->
              <b-col md="3">
                <b-form-group label="Code postal *" label-for="code postal">
                  <validation-provider #default="{ errors }" name="code postal" rules="required|length:5">
                    <cleave id="code-postal" v-model="prospect.moyen_contact.code_postal" :class="errors.length > 0 ? 'is-invalid' : ''" :options="options.codePostal" :raw="false" class="form-control" placeholder="Code postal" type="number" />
                    <b-form-invalid-feedback :state="errors.length > 0 ? false : null"> {{ errors[0] }} </b-form-invalid-feedback>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <!-- Ville -->
              <b-col md="3">
                <b-form-group label="Ville *" label-for="ville">
                  <validation-provider #default="{ errors }" name="ville" rules="required">
                    <b-form-select v-model="prospect.moyen_contact.ville_id" :state="errors.length > 0 ? false : null">
                      <b-form-select-option :value="null">Choisissez</b-form-select-option>
                      <b-form-select-option v-for="ville in villeOptions" :value="ville.id" :key="ville.id">{{ ville.ville }}</b-form-select-option>
                    </b-form-select>
                    <b-form-invalid-feedback :state="errors.length > 0 ? false : null"> {{ errors[0] }} </b-form-invalid-feedback>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <!-- <b-col md="3">
                <b-form-group label="Capital assure *" label-for="capital assure">
                  <validation-provider #default="{ errors }" name="Capital assure" rules="required">
                    <b-form-select v-model="objetIJH.capital_assure" :options="capitalOptions" :state="errors.length > 0 ? false : null" />
                    <b-form-invalid-feedback :state="errors.length > 0 ? false : null">
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </validation-provider>
                </b-form-group>
              </b-col> -->
            </b-row>
            <b-row class="align-items-center mb-1">
            
              <b-col md="12">
                <b-form-group
                  label="L'assuré, ou une ou des personnes de son entourage étroitement associées, exercent-ils ou ont-ils cessé d'exercer depuis moins d'un an des fonctions politiques, juridictionnelles ou administratives ? (pour plus de détails, voir l'onglet FAQ)">
                  <validation-provider v-slot="{ errors }" name="personne politiquement exposée" rules="required"
                    vid="is_ppe_ass_conjoint_a_assurer">
                    <b-form-radio-group id="ppe_1_option_sante_ijh" v-model="prospect.isPPE" :options="BooleanValue"
                      label="Prospect à assurer"></b-form-radio-group>
                    <b-form-invalid-feedback :state="errors.length > 0 ? false : null">
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>

          <b-col md="3" v-if="hasConjointBySituationFamiliale()">
            <b-form-group label="Conjoint à assurer ?">
              <validation-provider v-slot="{ errors }" name="Conjoint à assurer" rules="required"
                vid="is_conjoint_a_assurer">
                <b-form-radio-group id="conjoint_option_sante_ijh" v-model="objetIJH.conjoint" :options="BooleanValue"
                  label="Conjoint à assurer"></b-form-radio-group>
                <b-form-invalid-feedback :state="errors.length > 0 ? false : null">
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

        <!--Conjoint-->
        <b-row v-if="objetIJH.conjoint" class="align-items-center mb-1">
          <b-col md="12" sm="12">
            <h4 class="title-custom-wizard mt-2"><u>Conjoint</u></h4>
          </b-col>
          <!-- Civilité -->
          <b-col md="3">
            <b-form-group label="Civilité *" label-for="conjoint-civilite">
              <validation-provider #default="{ errors }" name="civilité du conjoint" rules="required">
                <b-form-select v-model="conjoint.civilite" :options="civilite" id="conjoint-civilite"
                  :state="errors.length > 0 ? false : null" />
                <b-form-invalid-feedback :state="errors.length > 0 ? false : null">Le champ civilité du conjoint est
                  obligatoire
                </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!-- Nom -->
          <b-col md="3">
            <b-form-group label="Nom *" label-for="conjoint-nom">
              <div class="form-control" readonly disabled v-if="
                  conjoint.statut_gda == 'ORANGE' ||
                  conjoint.statut_gda == 'ROUGE' ||
                  conjoint.statut_gda == 'VERT'
                ">
                {{ conjoint.nom }}
              </div>

              <validation-provider v-else #default="{ errors }" name="nom du conjoint" rules="required">
                <b-form-input id="conjoint-nom" v-model="conjoint.nom" :state="errors.length > 0 ? false : null"
                  class="text-capitalize" placeholder="Nom" type="text" />
                <b-form-invalid-feedback :state="errors.length > 0 ? false : null">Le champ nom du conjoint est
                  obligatoire
                </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!-- Prénom -->
          <b-col md="3">
            <b-form-group label="Prénom *" label-for="conjoint-prenom">
              <div class="form-control" readonly disabled v-if="
                  conjoint.statut_gda == 'ORANGE' ||
                  conjoint.statut_gda == 'ROUGE' ||
                  conjoint.statut_gda == 'VERT'
                ">
                {{ conjoint.prenom }}
              </div>
              <validation-provider v-else #default="{ errors }" name="prénom du conjoint" rules="required">
                <b-form-input id="conjoint-prenom" v-model="conjoint.prenom" :state="errors.length > 0 ? false : null"
                  class="text-capitalize" placeholder="Prénom" type="text" />
                <b-form-invalid-feedback :state="errors.length > 0 ? false : null">Le champ prénom du conjoint est
                  obligatoire
                </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!-- Date de naissance -->
          <b-col md="3">
            <b-form-group label="Date de naissance *" label-for="conjoint-date-naissance">
              <div class="form-control" readonly disabled v-if="conjoint.statut_gda == 'ORANGE' ||  conjoint.statut_gda == 'ROUGE' ||  conjoint.statut_gda == 'VERT'">
                {{ conjoint.date_naissance }}
              </div>
              <validation-provider v-else #default="{ errors }" name="date de naissance du conjoint" rules="required">
                <flat-pickr id="conjoint-date-naissance" v-model="conjoint.date_naissance"
                  :class="errors.length > 0 ? 'is-invalid' : ''" :config="configDateNaissance" class="form-control"
                  placeholder="Date de naissance"/>
                <b-form-invalid-feedback :state="errors.length > 0 ? false : null">Le champ date de naissance du
                  conjoint est obligatoire
                </b-form-invalid-feedback>
                <b-form-invalid-feedback :state="errorDateNaissanceConjoint ? false : null">
                  {{ errorDateNaissanceConjoint }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!-- <b-col md="3">
            <b-form-group label="Capital conjoint *" label-for="Capital_conjoint">
              <validation-provider #default="{ errors }" name="Capital conjoint" rules="required">
                <b-form-select v-model="objetIJH.capital_conjoint" :options="capitalOptions"
                  :state="errors.length > 0 ? false : null" />
                <b-form-invalid-feedback :state="errors.length > 0 ? false : null">
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col> -->
          <b-col md="12">
            <b-form-group
              label="Le conjoint, ou une ou des personnes de son entourage étroitement associées, exercent-ils ou ont-ils cessé d'exercer depuis moins d'un an des fonctions politiques, juridictionnelles ou administratives ? (pour plus de détails, voir l'onglet FAQ)">
              <validation-provider v-slot="{ errors }" name="personne politiquement exposée" rules="required">
                <b-form-radio-group id="ppe_2_option_sante_ijh" v-model="getEtude.Conjoint.isPPE"
                  :options="BooleanValue" label="Conjoint à assurer"></b-form-radio-group>
                <b-form-invalid-feedback :state="errors.length > 0 ? false : null">
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
    <!-- Garanties -->
    <!-- Text -->
    <b-row class="mt-4">
      <b-col md="12">
        <h4 class="title-custom-wizard"><u>Besoins</u></h4>
      </b-col>
    </b-row>
    <!-- Boucle -->
    <b-row v-for="(garantie, gr) in garanties.slice(0, 1)" :key="gr + 'garanties'">
      <b-col class="mt-2" md="12">
        <label>Quel est le besoin exprimé par le client ?</label>
        <p class="mb-0 mt-2 pb-0">Indemnité journalière</p>
        <div class="demo-inline-spacing mt-0 mb-2">
          <b-form-radio v-for="(gn, cpt) in garantie.garantieniveaux" :key="cpt + 'garantiesNiveaux'" v-model="garantie.garantieNiveauID" :value="[gn.id]" class="custom-control-primary">
            <span>{{ gn.garantie_niveau_libel }}</span>
            <!-- <span v-b-popover.hover.top="gn.garantie_details" v-ripple.400="'rgba(113, 102, 240, 0.15)'" :title="gn.garantie_niveau_libel" class="ml-1 cursor-pointer" variant="outline-primary">
              <feather-icon icon="InfoIcon" size="20" />
            </span> -->
          </b-form-radio>
        </div>
        <b-form-invalid-feedback :state="!hasSelectedGarantie">
          Veuillez renseigner le(s) champ(s) obligatoire(s)
        </b-form-invalid-feedback>
      </b-col>
    </b-row>

    <!-- Exigences -->
    <!-- Boucle -->
    <b-row>
      <b-col v-for="(exigence, er) in exigences" :key="er + 'exigences'" class="mt-2" md="6">
        <label>{{ titleClass(exigence.label) }} </label>
        <div class="demo-inline-spacing mt-0 mb-2">
          <b-form-radio v-for="(en, cpt) in exigence.exigenceniveaux" :key="cpt + 'exigencesNiveaux'"
            v-model="exigences[er].exigenceNiveauID" :value="[en.id]" class="custom-control-primary">
            <span v-b-popover.hover.top="
                explicationExigenceNiveauLibel(
                  exigence.label,
                  en.exigence_niveau_libel
                )
              " v-ripple.400="'rgba(113, 102, 240, 0.15)'" :title="titleClass(en.exigence_niveau_libel)"
              class="cursor-pointer" variant="outline-primary">
              {{ titleClass(en.exigence_niveau_libel) }}
            </span>
          </b-form-radio>
        </div>
        <b-form-invalid-feedback :state="!unselectedExigenceIds.includes(exigence.id)">
          Veuillez renseigner le(s) champ(s) obligatoire(s)
        </b-form-invalid-feedback>
      </b-col>
    </b-row>

    <!-- Buttons -->
    <b-row class="mt-4">
      <b-col lg="12">
        <b-button class="float-left" size="lg" variant="primary" @click="backStep">
          Précédent
        </b-button>
        <b-button class="float-right" size="lg" variant="primary" @click="checkValidateField(0)">
          Suivant
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Datarisquebesoin from '@/shared/constants/risquebesoin';
import {
  BPopover,
  BButton,
  VBPopover,
  BCol,
  BFormCheckbox,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormRadio,
  BFormRadioGroup,
  BFormSelect,
  BOverlay,
  BRow,
  VBTooltip,
  BAlert,
  BFormSelectOption,
} from 'bootstrap-vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import flatPickr from 'vue-flatpickr-component';
import Cleave from 'vue-cleave-component';
import moment from 'moment';
import { mapGetters } from 'vuex';
import Ripple from 'vue-ripple-directive';
import ToastificationContentVue from '@core/components/toastification/ToastificationContent.vue';
import vSelect from 'vue-select';
import {
  required,
  requiredIf,
  minLength,
  maxLength,
  between,
  email,
} from 'vuelidate/lib/validators';
export default {
  components: {
    BRow,
    BCol,
    BButton,
    BForm,
    BOverlay,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BFormRadioGroup,
    BFormRadio,
    BFormSelect,
    BAlert,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    ToastificationContentVue,
    flatPickr,
    Cleave,
    BPopover,
    BFormSelectOption,
  },
  directives: {
    'b-tooltip': VBTooltip,
    'b-popover': VBPopover,
    Ripple,
  },
  data() {
    return {
      infoDateEffet:
          "<b>ECA</b> : la date d'effet doit être au 1er du mois et incluse dans un quadrimestre suivant la date du jour<br>",
      is_a_distance_info:
          "Dans le cadre de votre mission, vous vous engagez à respecter l’ensemble des règles relatives au démarchage téléphonique, y compris la loi n°2021-402 du 8 avril 2021, le décret n°2022-34 du 17 janvier 2022 et le décret n°2022-1313 du 13 octobre 2022.<br><br><b>Vos obligations :</b><br><br>- Mettre en place une vente en deux temps lorsque vous démarchez par téléphone un prospect qui n’est pas client ou qui n’a pas sollicité votre appel de manière active.<br><br>-  Informer le prospect dès le début de l’appel que celui-ci est enregistré et qu’il peut obtenir une copie de cet enregistrement s’il en fait la demande.<br><br>- Mettre fin à l’appel si le prospect refuse l’enregistrement.<br><br>- Vous vous engagez à enregistrer l’ensemble des conversations téléphoniques qui auront amené à la conclusion du contrat d’assurance et à les conserver.<br><br>-  La signature électronique ne pourra intervenir lors du deuxième appel et vous ne pourrez pas l’accompagner durant ce processus de signature.<br><br>-  S’assurer de permettre la traçabilité et l’intégrité de l’ensemble des appels téléphoniques.<br><br>- Respecter strictement le décret du 13 octobre 2022 encadrant les jours, horaires et fréquence d’appels quand celui-ci s’applique. Les appels dans ce cas devront être passés entre 10h et 13h et entre 14h à 20h du lundi au vendredi. Ils sont en revanche interdits les samedis, dimanches et jours fériés. Cet encadrement s'applique aussi bien aux personnes non inscrites sur la liste Bloctel qu'à celles inscrites mais sollicitées dans le cadre d'un contrat en cours.<br><br>- Limitation stricte de l'accès aux enregistrements aux seuls agents de l'Autorité de contrôle prudentiel et de résolution et aux agents mentionnés aux articles L. 511-3 et L. 511-21 du code de la consommation.<br><br><b>Destruction des enregistrements :</b><br><br>-  Sans délai, lorsque le souscripteur ou l'adhérent éventuel s'est explicitement opposé à la poursuite de la communication téléphonique ou à la proposition commerciale<br><br>- En l'absence de réponse favorable à une proposition commerciale, dans un délai d'un mois à compter de la date de cette proposition (le souscripteur ou l'adhérent éventuel manifestant ainsi une absence d'intérêt ou son souhait de ne pas donner suite à cette proposition)",
      riaDate: null,
      pays: [],
      villeOptions: [],
      civilite: [
        { value: null, text: 'Choisissez' },
        { value: 'MR', text: 'M.' },
        { value: 'MME', text: 'Mme' },
      ],
      optionsVenteDistance: [
        { text: 'Oui', value: 1 },
        { text: 'Non', value: 0 },
      ],
      optionsTypeVente: [
        {
          text: 'Vente à distance en 1 temps',
          value: 'optin',
          infoBool:
              'Prospect ayant préalablement consenti à l’appel ou client.',
        },
        {
          text: 'Vente à distance en 2 temps',
          value: 'optout',
          infoBool:
              'Prospect n’ayant pas consenti à l’appel. Un délai de 24h s’appliquera avant la mise en place de la signature électronique.',
        },
      ],
      showLoading: false,
      errorDateNaissanceProspect: null,
      errorDateNaissanceConjoint: null,
      // Data implemented

      objetIJH: {
        conjoint: 0,
        date_effet: null,
        // capital_assure: null,
        capital_conjoint: null,
      },
      prospect: {
        date_naissance: null,
      },
      conjoint: {
        id: null,
        nom: null,
        prenom: null,
        date_naissance: null,
        type_lien_familial: 'CONJOINT',
        nom_naissance: null,
        code_postal_naissance: null,
        commune_naissance: null,
        pays_naissance: null,
      },
      garanties: [],
      exigences: [],
      devis: null,

      situationFamiliale: Datarisquebesoin.SITUATIONFAMILIALE,
      capitalOptions: [
        {
          value: null,
          text: 'Choisissez',
          disabled: true,
        },
        {
          value: '20',
          text: '20',
        },
        {
          value: '40',
          text: '40',
        },
        {
          value: '60',
          text: '60',
        },
        {
          value: '80',
          text: '80',
        },
        {
          value: '100',
          text: '100',
        },
      ],
      BooleanValue: [
        {
          value: 1,
          text: 'Oui',
        },
        {
          value: 0,
          text: 'Non',
        },
      ],
      options: {
        codePostal: {
          blocks: [5],
        },
        codePostalNaiss: {
          lowercase: true,
        },
      },
      config: {
        dateFormat: 'd/m/Y',
        allowInput: true,
        onKeyDown: (selectedDates, dateStr, instance, event) => {
          if (event.keyCode != 8) {
            var ele = document.activeElement;
            var val = ele.value;

            if (
              (val.length == 2 || val.length == 5) &&
                ele.getAttribute('id')
            ) {
              val += '/';
            }
            ele.value = val;
            ele.dispatchEvent(new Event('input'));
          }
        },
      },
      configDateNaissance: {
        dateFormat: 'd/m/Y',
        maxDate: new Date(),
        allowInput: true,
        onKeyDown: (selectedDates, dateStr, instance, event) => {
          if (event.keyCode != 8) {
            var ele = document.activeElement;
            var val = ele.value;

            if (
              (val.length == 2 || val.length == 5) &&
                ele.getAttribute('id')
            ) {
              val += '/';
            }
            ele.value = val;
            ele.dispatchEvent(new Event('input'));
          }
        },
      },
      configdateEffet: {
        dateFormat: 'd/m/Y',
        disable: [
          function (date) {
            const today = new Date();
            today.setDate(today.getDate());
            today.setHours(0, 0, 0, 0);
            return date < today;
          },
          function (date) {
            const dateMaxSL = new Date();
            const dateMaxECA = new Date();
            dateMaxSL.setMonth(dateMaxSL.getMonth() + 9);
            dateMaxECA.setFullYear(dateMaxECA.getFullYear() + 1, 0, 1);
            dateMaxSL.setHours(0, 0, 0, 0);
            dateMaxECA.setHours(0, 0, 0, 0);
            const datePlusMonth =
                dateMaxSL <= dateMaxECA ? dateMaxSL : dateMaxSL;
            return datePlusMonth < date;
          },
        ],
        allowInput: true,
        onKeyDown: (selectedDates, dateStr, instance, event) => {
          if (event.keyCode != 8) {
            var ele = document.activeElement;
            var val = ele.value;

            if (
              (val.length == 2 || val.length == 5) &&
                ele.getAttribute('id')
            ) {
              val += '/';
            }
            ele.value = val;
            ele.dispatchEvent(new Event('input'));
          }
        },
      },

      hasSelectedGarantie: false,
      unselectedExigenceIds: [],
      ppe: {
        assure: false,
        conjoint: false,
      },
    };
  },
  validations: {
    objetIJH: {
      date_effet: { required },
    },
  },
  computed: {
    ...mapGetters(['getEtude']),
  },
  watch: {
    'prospect.moyen_contact.code_postal': {
      immediate: true,
      handler(val) {
        console.log(this.prospect);
        if (val && val.length === 5) {
          this.$http
            .get(`/helpers/${val}/villes`)
            .then((res) => {
              if (res.data?.length > 0) {
                this.villeOptions = [...res.data];
                let obj = this.villeOptions.find(
                  (o) => o.id === this.prospect.moyen_contact.ville_id
                );
                if (typeof obj === 'undefined' || obj === null) {
                  this.prospect.moyen_contact.ville_id = null;
                }
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          this.villeOptions = [];
        }
      },
    },
    'devis.is_a_distance': {
      handler(val) {
        if (!val) {
          this.devis.type_vente = null;
        }
      },
    },
    getEtude: {
      handler: function (old, nld) {
        this.prospect = old.Tiers;
        this.conjoint = old.Conjoint;
        this.garanties =
            old.itemsRisque.ItemsRisque.length > 0
              ? old.itemsRisque.ItemsRisque[0].garanties
              : null;
        this.exigences =
            old.itemsRisque.ItemsRisque.length > 0
              ? old.itemsRisque.ItemsRisque[0].exigences
              : null;
        // this.orderExigences()
        this.devis =
            old.itemsRisque.ItemsRisque.length > 0
              ? old.itemsRisque.ItemsRisque[0].devis
              : null;
        this.objetIJH =
            old.itemsRisque.ItemsRisque.length > 0
              ? old.itemsRisque.ItemsRisque[0].objets.objet_ijh
              : {
                conjoint: 0,
                date_effet: null,
                situation_familiale: null
              };
      },
      deep: true,
      immediate: true,
    },
    'objetIJH.date_effet': {
      handler(val) {
        if (val) {
          this.checkDateFormat();
          if (!this.checkerDateEffet()) {
            this.objetIJH.date_effet = null;
            this.$refs.AssureRules.validate();
          }
        }
      },
      deep: true,
      immediate: true,
    },
    // 'objetIJH.capital_assure': {
    //   handler(val) {
    //     if (val) {
    //       this.objetIJH.capital_conjoint = this.objetIJH.capital_assure
    //     }
    //   },
    //   deep: true,
    //   immediate: true,
    // },

    prospect: {
      handler: function (old, nld) {
        this.prospect.original_civilite = old.civilite;
        this.prospect.original_date_naissance = old.date_naissance;
        this.prospect.moyen_contact.original_code_postal =
            old.moyen_contact.code_postal;
        this.prospect.original_nom = old.nom;
        this.prospect.original_prenom = old.prenom;
        this.prospect.original_nom_naissance = old.nom_naissance;
        this.prospect.original_code_postal_naissance =
            old.code_postal_naissance;
        this.prospect.original_commune_naissance = old.commune_naissance;
        this.prospect.original_pays_naissance = old.pays_naissance;
        this.prospect.moyen_contact.original_ville_id =
            old.moyen_contact.ville_id;
      },
      immediate: true,
    },
    conjoint: {
      handler: function (old, nld) {
        this.conjoint.original_nom = old.nom;
        this.conjoint.original_prenom = old.prenom;
        this.conjoint.original_date_naissance = old.date_naissance;
        this.conjoint.original_civilite = old.civilite;
        this.conjoint.original_nom = old.nom;
        this.conjoint.original_prenom = old.prenom;
        this.conjoint.original_nom_naissance = old.nom_naissance;
        this.conjoint.original_code_postal_naissance = old.code_postal_naissance;
        this.conjoint.original_commune_naissance = old.commune_naissance;
        this.conjoint.original_pays_naissance = old.pays_naissance;
        this.conjoint.moyen_contact.original_ville_id = old.moyen_contact.ville_id;
      },
      immediate: true,
    },
  },
  /*  beforeMount() {
         this.prospect.original_civilite = this.prospect.civilite
         this.prospect.original_date_naissance = this.prospect.date_naissance
         this.prospect.original_regime_obligatoire = this.prospect.regime_obligatoire
         this.prospect.moyen_contact.original_code_postal = this.prospect.moyen_contact.code_postal
         this.prospect.original_nom = this.prospect.nom
         this.prospect.original_prenom = this.prospect.prenom
         this.prospect.original_nom_naissance = this.prospect.nom_naissance
         this.prospect.original_code_postal_naissance = this.prospect.code_postal_naissance
         this.prospect.original_commune_naissance = this.prospect.commune_naissance    
         this.prospect.original_pays_naissance = this.prospect.pays_naissance
         this.prospect.original_regime_obligatoire = this.prospect.regime_obligatoire
         this.prospect.moyen_contact.original_ville_id = this.prospect.moyen_contact.ville_id
     
         this.conjoint.original_civilite = this.conjoint.civilite
         this.conjoint.original_date_naissance = this.conjoint.date_naissance
         this.conjoint.original_regime_obligatoire = this.conjoint.regime_obligatoire
         this.conjoint.original_nom = this.conjoint.nom
         this.conjoint.original_prenom = this.conjoint.prenom
         this.conjoint.original_nom_naissance = this.conjoint.nom_naissance
         this.conjoint.original_code_postal_naissance = this.conjoint.code_postal_naissance
         this.conjoint.original_commune_naissance = this.conjoint.commune_naissance
         this.conjoint.original_pays_naissance = this.conjoint.pays_naissance
         this.conjoint.original_regime_obligatoire = this.conjoint.regime_obligatoire
         this.conjoint.moyen_contact.original_ville_id = this.conjoint.moyen_contact.ville_id
         // this.orderExigences()
       }, */
  mounted() {
    this.$v.$reset();
    this.$v.objetIJH.$touch();
    this.$refs.AssureRules.validate();
    // if (!this.checkerDateEffet()) {
    //   this.objetIJH.date_effet = null
    //   this.$refs.AssureRules.validate()
    // }

    // this.orderExigences()
  },
  created() {
    this.$http
      .get('tiers/getPays')
      .then((r) => {
        this.pays = r.data;
        // console.log(r.data);
      })
      .catch((e) => {
        console.log(e);
      });
  },
  methods: {
    hasConjointBySituationFamiliale() {
      const situationFamilialeList = ['CONCUBIN', 'MARIE', 'PACSE']
      if (situationFamilialeList.includes(this.prospect.situation_familiale)) {
        return true
      }
      this.objetIJH.conjoint = 0
      return false
    },
    checkDateFormat() {
      const format = 'YYYY-MM-DD';
      const date = moment(this.objetIJH.date_effet, format, true);
      if (date.isValid()) {
        this.objetIJH.date_effet = date.format('DD/MM/YYYY');
      } else {
        this.objetIJH.date_effet = moment(
          this.objetIJH.date_effet,
          'DD/MM/YYYY'
        ).format('DD/MM/YYYY');
      }
    },
    getVilles(code) {
      if (code && code.length === 5) {
        this.$http
          .get(`/helpers/${code}/villes`)
          .then((res) => {
            if (res.data?.length > 0) {
              this.villeOptions = [...res.data];
              this.prospect.moyen_contact.ville = this.villeOptions[0].id;
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.villeOptions = [];
      }
    },
    orderExigences() {
      let listExigences = [
          'Soins Courants',
          'Hospitalisation',
          'Optique',
          'Dentaire',
          'Aides auditives',
        ],
        result = [];
      this.exigences.forEach(function (a) {
        result[listExigences.indexOf(a.label)] = a;
      });
      this.exigences = result;
    },
    explicationExigenceNiveauLibel(exigenceLabel, exigenceNiveauLabel) {
      const removeAccentsExigenceLabel = exigenceLabel
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
      const valueToUpperCaseExigenceLabel =
          removeAccentsExigenceLabel.toUpperCase();

      const removeAccentsExigenceNiveauLabel = exigenceNiveauLabel
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
      const valueToUpperCaseExigenceNiveauLabel =
          removeAccentsExigenceNiveauLabel.toUpperCase();

      const valueSearch =
          valueToUpperCaseExigenceNiveauLabel +
          ' ' +
          valueToUpperCaseExigenceLabel;

      let tableNiveauGarantie = {
        'NON SOINS COURANTS': 'Aucune prise en charge',
        'MIN SOINS COURANTS':
            'Consultations et visites spécialistes et généralistes remboursées à 100%',
        'MOYEN SOINS COURANTS':
            'Consultations et visites spécialistes et généralistes remboursées jusqu’à 150%',
        'FORT SOINS COURANTS':
            'Consultations et visites spécialistes et généralistes remboursées jusqu’à 200%',
        'MAX SOINS COURANTS':
            'Consultations et visites spécialistes et généralistes remboursées jusqu’à 300%',
        'MAXPLUS SOINS COURANTS':
            'Consultations et visites spécialistes et généralistes remboursées à 300% et plus',

        'NON HOSPITALISATION': 'Aucune prise en charge',
        'MIN HOSPITALISATION':
            'Frais de séjour, soins, honoraires, actes techniques remboursés à 100%',
        'MOYEN HOSPITALISATION':
            'Frais de séjour, soins, honoraires, actes techniques remboursés jusqu’à 150%',
        'FORT HOSPITALISATION':
            'Frais de séjour, soins, honoraires, actes techniques remboursés jusqu’à 200%',
        'MAX HOSPITALISATION':
            'Frais de séjour, soins, honoraires, actes techniques remboursés jusqu’à 300%',
        'MAXPLUS HOSPITALISATION':
            'Frais de séjour, soins, honoraires, actes techniques remboursés à 300% et plus',

        'NON OPTIQUE': 'Aucune prise en charge',
        'MIN OPTIQUE':
            'Equipement à tarif libre : monture + 2 verres dont au moins 1 complexe remboursés à 100%',
        'MOYEN OPTIQUE':
            'Equipement à tarif libre : monture + 2 verres dont au moins 1 complexe remboursés jusqu’à 200€',
        'FORT OPTIQUE':
            'Equipement à tarif libre : monture + 2 verres dont au moins 1 complexe remboursés jusqu’à 300€',
        'MAX OPTIQUE':
            'Equipement à tarif libre : monture + 2 verres dont au moins 1 complexe remboursés jusqu’à 400€',
        'MAXPLUS OPTIQUE':
            'Equipement à tarif libre : monture + 2 verres dont au moins 1 complexe remboursés à 400€ et plus',

        'NON DENTAIRE': 'Aucune prise en charge',
        'MIN DENTAIRE':
            'Soins et prothèses dentaires à tarif libre remboursés à 100%',
        'MOYEN DENTAIRE':
            'Soins et prothèses dentaires à tarif libre remboursés jusqu’à 150%',
        'FORT DENTAIRE':
            'Soins et prothèses dentaires à tarif libre remboursés jusqu’à 200%',
        'MAX DENTAIRE':
            'Soins et prothèses dentaires à tarif libre remboursés jusqu’à 300%',
        'MAXPLUS DENTAIRE':
            'Soins et prothèses dentaires à tarif libre remboursés à 300% et plus',

        'NON AIDES AUDITIVES': 'Aucune prise en charge',
        'MIN AIDES AUDITIVES':
            'Equipement à tarif libre remboursé par la sécurité sociale remboursé à 100%',
        'MOYEN AIDES AUDITIVES':
            'Equipement à tarif libre remboursé par la sécurité sociale remboursé jusqu’à 150%',
        'FORT AIDES AUDITIVES':
            'Equipement à tarif libre remboursé par la sécurité sociale remboursé jusqu’à 250%',
        'MAX AIDES AUDITIVES':
            'Equipement à tarif libre remboursé par la sécurité sociale remboursé jusqu’à 350%',
        'MAXPLUS AIDES AUDITIVES':
            'Equipement à tarif libre remboursé par la sécurité sociale remboursé au delà de 350%',
      };
      return tableNiveauGarantie[valueSearch];
    },
    titleClass(word) {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    },
    backStep() {
      this.$store.commit('setStepTarif', {
        step: {
          indexStep: 0,
          active: 'choix',
        },
      });
    },
    async checkValidateField(index) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });

      this.showLoading = true;
      this.$v.$reset();
      this.$v.objetIJH.$touch();

      if (this.$v.objetIJH.$error) {
        this.showLoading = false;
        return 0;
      }

      const isValid = await this.$refs.AssureRules.validate();
      if (!isValid) {
        this.showLoading = false;
        return 0;
      }

      if (
        this.getEtude.itemsRisque.ItemsRisque[index].garanties[0]
          .garantieNiveauID.length == 0
      ) {
        this.hasSelectedGarantie = true;
        this.showLoading = false;
        return 0;
      } else {
        this.hasSelectedGarantie = false;
      }

      this.unselectedExigenceIds = [];
      this.getEtude.itemsRisque.ItemsRisque[index].exigences.forEach(
        (element) => {
          if (element.exigenceNiveauID.length == 0) {
            this.unselectedExigenceIds.push(element.id);
          }
        }
      );

      if (this.unselectedExigenceIds.length > 0) {
        this.showLoading = false;
        return 0;
      }

      let resultOriginalData = await this.checkOriginalData();

      if (resultOriginalData) {
        this.$swal({
          html: `<p class="text-justify" style="font-size: 15px">Attention, vous souhaitez modifier une donnée potentiellement tarifante pour un devis non encore souscrit ou un contrat souscrit par l'intermédiaire de BubbleIn.
                        <br><br>
                        Les devis en cours d'étude seront modifiés avec ces nouvelles informations. Les devis déjà envoyés ou les contrats en cours de signature seront classés sans suite et il conviendra de les refaire. Si vous avez souscrit un contrat, il conviendra de vérifier la nécessité de procéder à un avenant.
                        <br><br>
                        Souhaitez-vous confirmer cette modification ?</p>`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Oui',
          cancelButtonText: 'Non',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
            html: 'text-left',
          },
          buttonsStyling: false,
        })
          .then((confirmed) => {
            if (confirmed.value) {
              this.faireTarif(index);
              this.prospect.original_civilite = this.prospect.civilite;
              this.prospect.original_date_naissance =
                  this.prospect.date_naissance;
              this.prospect.moyen_contact.original_code_postal =
                  this.prospect.moyen_contact.code_postal;
              this.prospect.original_nom = this.prospect.nom;
              this.prospect.original_prenom = this.prospect.prenom;
              this.prospect.original_nom_naissance = this.prospect.nom_naissane;
              this.prospect.original_code_postal_naissance =
                  this.prospect.code_postal_naissance;
              this.prospect.original_commune_naissance =
                  this.prospect.commune_naissance;
              this.prospect.original_pays_naissance =
                  this.prospect.pays_naissance;
              this.prospect.moyen_contact.original_ville_id =
                  this.prospect.moyen_contact.ville_id;

              this.conjoint.original_civilite = this.conjoint.civilite;
              this.conjoint.original_date_naissance =
                  this.conjoint.date_naissance;
              this.conjoint.moyen_contact.original_code_postal =
                  this.conjoint.moyen_contactcode_postal;
              this.conjoint.original_nom = this.conjoint.nom;
              this.conjoint.original_prenom = this.conjoint.prenom;
              this.conjoint.original_nom_naissance =
                  this.conjoint.nom_naissance;
              this.conjoint.original_code_postal_naissance =
                  this.conjoint.code_postal_naissance;
              this.conjoint.original_commune_naissance =
                  this.conjoint.commune_naissance;
              this.conjoint.original_pays_naissance =
                  this.conjoint.pays_naissance;
              this.conjoint.moyen_contact.original_ville_id =
                  this.conjoint.moyen_contact.ville_id;
              // this.showLoading = false
            } else {
              this.showLoading = false;
              window.scrollTo({
                top: 0,
                behavior: 'smooth',
              });
            }
          })
          .catch(() => {
            this.showLoading = false;
          })
          .finally(() => { });
      } else {
        this.faireTarif(index);
      }
    },

    checkOriginalData() {
      if (
        (this.prospect.date_naissance !==
            this.prospect.original_date_naissance &&
            this.prospect.original_date_naissance != '' &&
            this.prospect.original_date_naissance != null) ||
          //prospect
          (this.prospect.civilite != this.prospect.original_civilite &&
            this.prospect.original_civilite != '' &&
            this.prospect.original_civilite != null) ||
          (this.prospect.nom != this.prospect.original_nom &&
            this.prospect.original_nom != '' &&
            this.prospect.original_nom != null) ||
          (this.prospect.prenom != this.prospect.original_prenom &&
            this.prospect.original_prenom != '' &&
            this.prospect.original_prenom != null) ||
          (this.prospect.nom_naissance != this.prospect.original_nom_naissance &&
            this.prospect.original_nom_naissance != '' &&
            this.prospect.original_nom_naissance != null) ||
          (this.prospect.code_postal_naissance !=
            this.prospect.original_code_postal_naissance &&
            this.prospect.original_code_postal_naissance != '' &&
            this.prospect.original_code_postal_naissance != null) ||
          (this.prospect.commune_naissance !=
            this.prospect.original_commune_naissance &&
            this.prospect.original_commune_naissance != '' &&
            this.prospect.original_commune_naissance != null) ||
          (this.prospect.pays_naissance !=
            this.prospect.original_pays_naissance &&
            this.prospect.original_pays_naissance != '' &&
            this.prospect.original_pays_naissance != null) ||
          (this.prospect.moyen_contact.ville_id !=
            this.prospect.moyen_contact.original_ville_id &&
            this.prospect.moyen_contact.original_ville_id != '' &&
            this.prospect.moyen_contact.original_ville_id != null) ||
          (this.prospect.moyen_contact.code_postal !=
            this.prospect.moyen_contact.original_code_postal &&
            this.prospect.moyen_contact.original_code_postal != '' &&
            this.prospect.moyen_contact.original_code_postal != null) ||
          //Conjoint
          (this.conjoint.date_naissance !=
            this.conjoint.original_date_naissance &&
            this.conjoint.original_date_naissance != '' &&
            this.conjoint.original_date_naissance != null) ||
          (this.conjoint.civilite != this.conjoint.original_civilite &&
            this.conjoint.original_civilite != '' &&
            this.conjoint.original_civilite != null) ||
          (this.conjoint.nom != this.conjoint.original_nom &&
            this.conjoint.original_nom != '' &&
            this.conjoint.original_nom != null) ||
          (this.conjoint.prenom != this.conjoint.original_prenom &&
            this.conjoint.original_prenom != '' &&
            this.conjoint.original_prenom != null) ||
          (this.conjoint.nom_naissance != this.conjoint.original_nom_naissance &&
            this.conjoint.original_nom_naissance != '' &&
            this.conjoint.original_nom_naissance != null) ||
          (this.conjoint.code_postal_naissance !=
            this.conjoint.original_code_postal_naissance &&
            this.conjoint.original_code_postal_naissance != '' &&
            this.conjoint.original_code_postal_naissance != null) ||
          (this.conjoint.commune_naissance !=
            this.conjoint.original_commune_naissance &&
            this.conjoint.original_commune_naissance != '' &&
            this.conjoint.original_commune_naissance != null) ||
          (this.conjoint.pays_naissance !=
            this.conjoint.original_pays_naissance &&
            this.conjoint.original_pays_naissance != '' &&
            this.conjoint.original_pays_naissance != null)
      ) {
        return true;
      } else {
        return false;
      }
    },
    changeDisabledDate(day) {
      this.configdateEffet.disable = [
        function (date) {
          const today = new Date();
          today.setDate(today.getDate() + day);
          today.setHours(0, 0, 0, 0);
          return date < today;
        },
        function (date) {
          const dateMaxSL = new Date();
          const dateMaxECA = new Date();
          dateMaxSL.setMonth(dateMaxSL.getMonth() + 9);
          dateMaxECA.setFullYear(dateMaxECA.getFullYear() + 1, 0, 1);
          dateMaxSL.setHours(0, 0, 0, 0);
          dateMaxECA.setHours(0, 0, 0, 0);
          const datePlusMonth = dateMaxSL >= dateMaxECA ? dateMaxSL : dateMaxSL;
          return datePlusMonth < date;
        },
      ];
    },
    checkerDateEffet() {
      const dateDuJour = moment().format('YYYY-MM-DD');
      const effetDate = moment(this.objetIJH.date_effet, 'DD/MM/YYYY').format(
        'YYYY-MM-DD'
      );
      const dateDuJourPlus9Mois = moment()
        .add(9, 'months')
        .format('YYYY-MM-DD');
        // if (this.objetIJH.ria) {
        //   let riaDateLocal = moment().add(35, 'days').format('YYYY-MM-DD')
        //   this.changeDisabledDate(35)
        //   if (this.devis.type_vente == 'optout') {
        //     riaDateLocal = moment().add(36, 'days').format('YYYY-MM-DD')
        //     this.changeDisabledDate(36)
        //   } else {
        //     riaDateLocal = moment().add(35, 'days').format('YYYY-MM-DD')
        //     this.changeDisabledDate(35)
        //   }

      //   if (!moment(effetDate).isBetween(riaDateLocal, dateDuJourPlus9Mois, null, '[]')) {
      //     // this.objetIJH.date_effet = null
      //     return false
      //   }
      // } else {
      //   this.changeDisabledDate(0)
      //   if (!moment(effetDate).isBetween(dateDuJour, dateDuJourPlus9Mois, null, '[]')) {
      //     // this.objetIJH.date_effet = null
      //     return false
      //   }
      // }
      return true;
    },
    async faireTarif(index) {
      // this.getEtude.itemsRisque.ItemsRisque[index].objets.objet_ijh = this.objetIJH
      this.getEtude.itemsRisque.ItemsRisque[index].objets.objet_ijh.date_effet = this.objetIJH.date_effet;
      this.getEtude.itemsRisque.ItemsRisque[index].objets.objet_ijh.conjoint = this.objetIJH.conjoint;
      this.getEtude.Tiers = this.prospect;
      let chooseRisque = this.getEtude.itemsRisque.ItemsRisque[0];
      let risqueItem = this.getEtude;
      risqueItem.itemsRisque.ItemsRisque = [];
      risqueItem.itemsRisque.ItemsRisque.push(chooseRisque);
      // risqueItem.objetIJH = this.objetIJH

      await this.persistObject(risqueItem);
      this.showLoading = false;
      return new Promise((resolve, reject) => {
        resolve(true);
      });
    },
    async persistObject(risqueItem) {
      await this.$http
        .post('portefeuilles/addDevisPortefeuille', risqueItem)
        .then((response) => {
          let conjoint = response.data[2];

          this.$store.commit('setObjetConjoint', {
            Conjoint: conjoint,
          });
          return this.getTarifData(risqueItem, 0, conjoint);
            
        })
        .catch((e) => {
          this.errors = e.response.data.errors;
        });
    },
    async getTarifData(risqueItem, risque, conjoint) {
      try {
        const garantiesValues =
            this.getEtude.itemsRisque.ItemsRisque[risque].garanties;
        garantiesValues.forEach((item, index) => {
          if (garantiesValues[index].garantieNiveauID.length <= 0) {
            this.getEtude.itemsRisque.ItemsRisque[risque].garanties[
              index
            ].garantieNiveauID = [];
            this.getEtude.itemsRisque.ItemsRisque[risque].garanties[
              index
            ].garantieNiveauID.push(
              garantiesValues[index].garantieniveaux.find(
                (item) => item.garantie_niveau_libel == 'Non'
              ).id
            );
          }
        });
        risqueItem.itemsRisque.ItemsRisque[risque].garanties = this.getEtude.itemsRisque.ItemsRisque[risque].garanties;
        let data = {
          conjoint: conjoint,
          assure: this.prospect,
          isTarification: true,
          risque: {
            objet: risqueItem.itemsRisque.ItemsRisque[risque].objets,
            produits: risqueItem.itemsRisque.ItemsRisque[risque].produits,
            garanties: risqueItem.itemsRisque.ItemsRisque[risque].garanties,
            risque: risqueItem.itemsRisque.ItemsRisque[risque].risque,
            devis: risqueItem.itemsRisque.ItemsRisque[risque].devis.id,
          },
        };

        await this.$http
          .post('portefeuilles/getTarif', data)
          .then((response) => {
            this.getEtude.itemsRisque.ItemsRisque[risque].produits.tarif = [];
            this.getEtude.itemsRisque.ItemsRisque[risque].produits =
                response.data;
            this.$store.commit('setItemsRisqueGlobal', {
              ItemsRisque: risqueItem.itemsRisque.ItemsRisque,
            });
          });

        this.$store.commit('setStepTarif', {
          step: {
            indexStep: 2,
            active: 'comparatif',
          },
        });

        // this.showLoading = false
      } catch (e) {
        this.errors = e.response.data.errors;
      }
    },
  },
};
</script>

<style lang="scss"></style>

<style lang="scss" scoped>
  .title-custom-wizard {
    color: #4d25bc;
    margin-bottom: 20px;
  }

  @media only screen and (min-width: 700px) {
    #lg-popover .popover {
      width: 600px;
      max-width: none; // Required for popovers wider than 276px (Bootstrap's max-width for popovers)
    }
  }

  label {
    font-weight: 900;
  }

  ::-webkit-input-placeholder {
    /* WebKit browsers */
    text-transform: none;
  }

  :-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    text-transform: none;
  }

  ::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    text-transform: none;
  }

  :-ms-input-placeholder {
    /* Internet Explorer 10+ */
    text-transform: none;
  }

  ::placeholder {
    /* Recent browsers */
    text-transform: none;
  }
</style>